import PropTypes from 'prop-types';

import './index.less';

function Card({
  children,
  variant = 'primary',
  isSelected = false,
  isDisabled = false,
  isHoverDisabled = false,
  onClick,
  'data-testid': dataTestId,
  ...rest
}) {
  const cardClasses = [
    'card',
    `card--${variant}`,
    isSelected && !isDisabled ? 'card--selected' : '',
    isDisabled ? 'card--disabled' : '',
    isHoverDisabled ? 'card--hover-disabled' : '',
  ].filter(Boolean).join(' ');

  const handleClick = (event) => {
    if (!isDisabled && !isHoverDisabled && onClick) {
      onClick(event);
    }
  };

  const handleKeyDown = (event) => {
    if (!isDisabled && !isHoverDisabled && onClick && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      onClick(event);
    }
  };

  return (
    <div
      className={cardClasses}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={onClick && !isDisabled && !isHoverDisabled ? 0 : undefined}
      data-testid={dataTestId || 'card'}
      {...rest}
    >
      {children}
    </div>
  );
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'success', 'error', 'warning']),
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isHoverDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  'data-testid': PropTypes.string,
};

Card.defaultProps = {
  variant: 'primary',
  isSelected: false,
  isDisabled: false,
  isHoverDisabled: false,
  onClick: undefined,
  'data-testid': undefined,
};

export default Card;